// @flow
export const getMeridian = (time: number): string => (time >= 43200 ? 'PM' : 'AM');

export const transformSeconds = (seconds: number, format: number = 12): string => {
  let appereanceTime = seconds;
  if (format === 12) {
    appereanceTime = seconds % (60 * 60 * 12);
  }

  const hours = Math.floor(appereanceTime / (60 * 60));
  const minutes = Math.floor((appereanceTime % (60 * 60)) / 60);
  return `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}`;
};

export const getDateDaySeconds = (
  date: Date,
) => date.getHours() * 60 * 60 + date.getMinutes() * 60 + date.getSeconds();

export const transformTime = (timestamp: number, format: number = 12): string => {
  const date = new Date(timestamp * 1000);
  const seconds = getDateDaySeconds(date);

  let appereanceTime = seconds;
  if (format === 12) {
    appereanceTime = seconds % (60 * 60 * 12);
  }

  const hours = Math.floor(appereanceTime / (60 * 60));
  const minutes = Math.floor((appereanceTime % (60 * 60)) / 60);
  return `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}`;
};

export const getUTCSeconds = (
  date: Date,
) => date.getUTCSeconds() + date.getUTCMinutes() * 60 + date.getUTCHours() * 60 * 60;

export const getMinutes = (time: number): number => Math.ceil(time / 60);

export const parseTime = (time: string) => {
  let hours = parseInt(time.split(':')[0], 10);
  const minutes = parseInt(time.split(':')[1], 10);
  let timeFrame = 'AM'; // 0 --> AM
  if (hours > 12) {
    hours %= 13;
    timeFrame = 'PM'; // 1 --> PM
  }
  return { hours, minutes, timeFrame };
};

export const getTimestamp = (date: number): number => Math.floor(date / 1000);

export const transformDateStringToDaySeconds = (dateString: string): number => getDateDaySeconds(new Date(dateString));



// WEBPACK FOOTER //
// ./src/scripts/utils/time.js